<template>
  <div
    class="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8"
  >
    <div class="max-w-md w-full space-y-8">
      <div>
        <h1 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Set New Password
        </h1>
        <p class="mt-2 text-center text-sm text-gray-600">
          Please enter your new password.
        </p>
      </div>
      <form @submit.prevent="resetPassword" class="mt-8 space-y-6">
        <div
          v-if="message"
          :class="[
            'mb-4 p-3 rounded border',
            success
              ? 'bg-green-100 text-green-700 border-green-300'
              : 'bg-red-100 text-red-700 border-red-300',
          ]"
        >
          {{ message }}
        </div>
        <div class="rounded-md shadow-sm -space-y-px">
          <div>
            <input
              :type="showPassword ? 'text' : 'password'"
              v-model="newPassword"
              required
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-gray-500 focus:border-gray-500 focus:z-10 sm:text-sm"
              placeholder="New Password"
            />
          </div>
          <div>
            <input
              :type="showPassword ? 'text' : 'password'"
              v-model="confirmPassword"
              required
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-gray-500 focus:border-gray-500 focus:z-10 sm:text-sm"
              placeholder="Confirm New Password"
            />
          </div>
        </div>

        <div class="flex items-center justify-end">
          <div class="text-sm">
            <button
              @click="toggleShowPassword"
              type="button"
              class="font-medium text-gray-600 hover:text-gray-900 focus:outline-none"
            >
              {{ showPassword ? "Hide password" : "Show password" }}
            </button>
          </div>
        </div>

        <div>
          <button
            type="submit"
            :disabled="loading || !passwordsMatch"
            class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition duration-300 ease-in-out disabled:opacity-50"
          >
            {{ loading ? "Resetting..." : "Reset Password" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { verifyResetToken, resetPassword } from "@/services/authService";

export default {
  name: "PasswordResetConfirm",
  data() {
    return {
      newPassword: "",
      confirmPassword: "",
      showPassword: false,
      message: "",
      success: false,
      loading: false,
      tokenVerified: false,
    };
  },
  computed: {
    passwordsMatch() {
      return (
        this.newPassword &&
        this.confirmPassword &&
        this.newPassword === this.confirmPassword
      );
    },
  },
  methods: {
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },
    async verifyToken() {
      try {
        const response = await verifyResetToken(this.$route.params.uid,this.$route.params.token);
        this.tokenVerified = response.valid;
      } catch (error) {
        this.message = error.message;
        this.success = false;
      }
    },
    async resetPassword() {
      if (!this.passwordsMatch) {
        this.message = "Passwords do not match.";
        this.success = false;
        return;
      }

      this.loading = true;
      this.message = "";
      try {
        await resetPassword(
          this.$route.params.uid,
          this.$route.params.token,
          this.newPassword
        );
        this.success = true;
        this.message =
          "Password has been reset successfully. You can now login with your new password.";
        setTimeout(() => {
          this.$router.push("/login");
        }, 1000);
      } catch (error) {
        this.success = false;
        this.message = error.message;
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    await this.verifyToken();
  },
};
</script>
